import React from "react";
import FAQ from "@components/blocks/FAQ/FAQ";
import ShopikoFAQData from "@components/blocks/FAQ/data/ShopikoFAQData";

const TabFAQ = () => {
	return (
	  <>
		  <FAQ data={ShopikoFAQData} color={'color-brand-green-400'} size={'900'}/>
	  </>
	)
}

export default TabFAQ;